import { Suspense } from 'react';
import { loadable } from '@direct-frontend/modules-render';
import { PageStub } from '#shared/components/PageStub';

const PromotionLazy = loadable(() => import(/* webpackChunkName: "PagesLight" */ './PromotionSuspense'));

export const PromotionAsync = () => (
    <Suspense fallback={<PageStub />}>
        <PromotionLazy />
    </Suspense>
);
